var _defs, _path, _path2, _path3, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgICart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "main_data",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#130f30;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m14.18,3.32c-.09.34-.18.69-.26,1.03-.18.74-.33,1.48-.55,2.21-.21.71-.74,1.11-1.47,1.19-1.39.16-2.78.3-4.18.44-.7.07-1.41.15-2.12.21-.17.01-.23.09-.29.23-.16.4-.06.81.28,1.05.16.11.33.13.52.13,1.93,0,3.86,0,5.78,0,.06,0,.13,0,.19.01.16.03.25.15.25.3,0,.15-.11.27-.26.3-.05,0-.1,0-.14,0-1.95,0-3.9,0-5.85,0-1.1,0-1.8-1.06-1.35-2.07.09-.2.1-.36.03-.57-.62-1.86-1.24-3.72-1.85-5.58-.14-.42-.41-.62-.86-.62-.3,0-.6,0-.9,0-.26,0-.41-.18-.34-.4.04-.12.12-.21.24-.21.47,0,.94-.03,1.4.04.52.08.85.44,1.03.94.08.23.16.45.22.68.03.1.08.14.19.14,1.63.02,3.25.04,4.88.07,1.66.02,3.32.05,4.99.07.18,0,.31.07.4.22v.16Zm-.7.25c-3.18-.05-6.33-.09-9.5-.14.01.04.01.07.02.09.46,1.39.92,2.79,1.38,4.18.03.08.06.1.14.09.5-.05.99-.1,1.49-.16,1.6-.17,3.2-.33,4.8-.5.55-.06.87-.34,1.01-.88.12-.49.24-.99.36-1.48.1-.4.19-.79.29-1.21Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m5.08,14c-.77,0-1.39-.63-1.39-1.4,0-.77.63-1.4,1.4-1.39.76,0,1.4.64,1.39,1.4,0,.77-.63,1.39-1.4,1.39Zm-.77-1.39c0,.43.34.77.77.77.42,0,.77-.34.78-.77,0-.43-.35-.78-.78-.78-.42,0-.77.35-.77.78Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m9.58,12.6c0-.77.63-1.4,1.39-1.39.77,0,1.39.63,1.39,1.4,0,.77-.62,1.39-1.4,1.39-.77,0-1.39-.62-1.39-1.4Zm1.4.77c.42,0,.77-.35.77-.77,0-.42-.35-.77-.77-.77-.43,0-.79.36-.78.78,0,.43.35.77.78.77Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5.22,
    y: 4.67,
    width: 0.28,
    height: 2.79,
    transform: "translate(-1.56 1.87) rotate(-17.29)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.58,
    y: 3.98,
    width: 0.28,
    height: 0.38,
    transform: "translate(-1 1.53) rotate(-16.68)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgICart);
export default __webpack_public_path__ + "static/media/i_cart.7763468f95db58cfecb32d54002e76a2.svg";
export { ForwardRef as ReactComponent };